import { translations } from '../utils/translations';
import { SET_LANGUAGE } from '../utils/Constants';


const initialState = {
    language: "es",
    translations,
};

const common = (state = initialState, action) => {
    switch (action.type) {
        case SET_LANGUAGE:
            return { ...state, language: action.data }
        default:
            return state;
    }
}

export default common;
